import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { RoleComponent } from './components/role/role.component';
import { CreateRoleComponent } from './components/role/create-role/create-role.component';
import { UpdateRoleComponent } from './components/role/update-role/update-role.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxBootstrapConfirmComponent } from './components/ngx-bootstrap-confirm/ngx-bootstrap-confirm.component';
import { NgxBootstrapConfirmService } from './components/ngx-bootstrap-confirm/ngx-bootstrap-confirm.service';
import { ToastrModule } from 'ngx-toastr';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { roleReducer } from './store/Role/RoleReducer';
import { HomeComponent } from './components/home/home.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { UpdateUserComponent } from './components/user-management/update-user/update-user.component';
import { CreateUserComponent } from './components/user-management/create-user/create-user.component';
import { AccordionModule } from './components/accordion/accordion.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UpdateApplicationAccessesComponent } from './components/user-management/update-application-accesses/update-application-accesses.component';
import { MainComponent } from './components/main/main.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SpinnerInterceptor } from './service/spinner.interceptor';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ImportUsersComponent } from './components/import-users/import-users.component';
import { UpdateAttributesComponent } from './components/user-management/update-attributes/update-attributes.component';
import { LoginComponent } from './components/login/login.component';
import { BaxterAuthModule } from '@baxter-jenkins/authenticator';
import { ChangePasswordComponent } from './components/user-management/change-password/change-password.component';
import { JwtInterceptor } from '@clearing-hub/angular-common';

@NgModule({
  declarations: [
    AppComponent,
    RoleComponent,
    CreateRoleComponent,
    UpdateRoleComponent,
    NgxBootstrapConfirmComponent,
    HomeComponent,
    UserManagementComponent,
    UpdateUserComponent,
    CreateUserComponent,
    UpdateApplicationAccessesComponent,
    MainComponent,
    SidebarComponent,
    ImportUsersComponent,
    UpdateAttributesComponent,
    LoginComponent,
    ChangePasswordComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxSpinnerModule.forRoot(),
    BaxterAuthModule.forRoot({
      loginUrl: '/adm/api/authentication/login',
      logoutUrl: '/adm/api/authentication/signout',
      userPoolConfigUrl: '/adm/api/authentication/user-pool',
      isRegistrationEnabled: false,
      registerUrl: '/adm/api/authentication/register',
      localStorageUserKey: 'currentAdmin',
      passwordPolicy: {
        MinimumLength: 8,
        RequireLowercase: true,
        RequireNumbers: true,
        RequireSymbols: true,
        RequireUppercase: true,
        TemporaryPasswordValidityDays: 7,
      },
    }),
    AccordionModule,
    FormsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes, {
      initialNavigation: 'enabledBlocking',
      useHash: true,
    }),
    StoreModule.forRoot({}),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    StoreModule.forFeature('role', roleReducer),
    NgSelectModule,
    NgxDatatableModule.forRoot({
      messages: {
        emptyMessage: 'No data to display',
        totalMessage: 'total',
        selectedMessage: 'selected',
      },
    }),
  ],
  providers: [
    BsModalService,
    NgxBootstrapConfirmService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
      deps: [NgxSpinnerService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
